import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=0cbbdb9e"
import script from "./startScreen.ts?vue&type=script&lang=js&external"
export * from "./startScreen.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports